module.exports = __webpack_public_path__ + "img/cleaf_banner_contact.cc7b8eae.jpg";